<script>
  export let idArticulo;
  export let fechaSolicitud;
  export let documento;
  export let figurasDoc;
  export let documentoFileDoc;
  export let documentoFilePdf;
  export let version;
  export let showInfo;
  export let miRol;
  export let revisores;
  export let lettersAuthorsDoc;
  export let lettersEditorsDoc;
  export let showReviewers;
  export let collapsed;

  import ArticleAuthorItem from "./ArticleAuthorItem.svelte";
  import ArticleFigureItem from "./ArticleFigureItem.svelte";
  import ArticleVersionReviewerItem from "./ArticleVersionReviewerItem.svelte";

  import { getId } from "../utils/getId";
  import { openDocument } from "../utils/openDocument";

  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  let collapse = true;

  let toggleCollapse = () => {
    collapse = !collapse;
  };
</script>

<style>
  div.articleVersion {
    width: 100%;
    margin-top: 40px;
    color: var(--revista-black);
  }

  div.articleRow {
    width: 100%;
    padding: 10px;
    border-top-color: lightgray;
    border-top-width: 1px;
    border-top-style: solid;
    border-left-color: lightgray;
    border-left-width: 1px;
    border-left-style: solid;
    border-right-color: lightgray;
    border-right-width: 1px;
    border-right-style: solid;
  }

  div.header {
    display: flex;
    justify-content: center;
  }

  div.title {
    font-weight: bold;
    font-size: 18px;
    display: flex;
    flex-direction: column;
  }

  span.titleEN {
    font-size: 14px;
    font-weight: normal;
  }

  div.subtitle {
    font-weight: bold;
  }

  div.subtitleEN {
    font-weight: bold;
    margin-top: 10px;
  }

  div.resumen {
    text-align: justify;
  }

  div.manuscript {
    display: flex;
    align-items: center;
  }

  div.manuscript:not(:first-child) {
    margin-top: 20px;
  }

  div.imageIcon {
    margin-right: 20px;
  }

  div.imageIcon img {
    width: 50px;
  }

  div.description {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  div.options {
    display: flex;
  }

  div.options img {
    width: 20px;
    height: 20px;
    margin-left: 5px;
  }

  img.imgButton {
    cursor: pointer;
  }

  div.collapsed {
    cursor: pointer;
  }

  img.collapseImg {
    width: 15px;
    margin-left: 10px;
  }

  span.id {
    font-weight: normal;
    font-size: 12px;
  }
</style>

<div class="articleVersion">
  <div
    class="articleRow header {collapsed ? 'collapsed' : ''}"
    on:click={collapsed ? toggleCollapse() : null}>
    <h4>{dict['version']} {version}</h4>
    {#if collapsed}
      <img
        class="collapseImg"
        src={collapse ? '/images/revista/down-arrow.svg' : '/images/revista/up-arrow.svg'}
        alt="Collapse Icon" />
    {/if}
  </div>
  {#if !collapsed || (collapsed && !collapse)}
    <div class="articleRow title">
      <span class="id">{getId(fechaSolicitud, idArticulo)}</span>
      {documento.titulo}
      <span class="titleEN">{documento.tituloEN}</span>
    </div>
    <div class="articleRow">
      {#each documento.autores as autor, i}
        <ArticleAuthorItem {autor} last={i === documento.autores.length - 1} />
      {/each}
    </div>
    <div class="articleRow">
      <div class="subtitle">Resumen:</div>
      <div class="resumen">{documento.abstract}</div>
      <div class="subtitleEN">Abstract:</div>
      <div class="resumen">{documento.abstractEN}</div>
    </div>
    <div class="articleRow">
      <div class="subtitle">Palabras Clave:</div>
      <div class="keywords">
        {#each documento.palabrasClave as palabraClave, index}
          <span>{index > 0 ? ' · ' : ''}{palabraClave}</span>
        {/each}
      </div>
      <div class="subtitleEN">Keywords:</div>
      <div class="keywords">
        {#each documento.palabrasClaveEN as palabraClave, index}
          <span>{index > 0 ? ' · ' : ''}{palabraClave}</span>
        {/each}
      </div>
    </div>
    {#if showInfo}
      <div class="articleRow">
        <div class="manuscript">
          <div class="imageIcon">
            <a
              href="#"
              onclick="return false;"
              on:click={() => openDocument(documentoFileDoc)}>
              <img src="/images/revista/docx.svg" alt="Document DOCX" />
            </a>
          </div>
          <div class="description">
            <a
              href="#"
              onclick="return false;"
              on:click={() => openDocument(documentoFileDoc)}>
              {dict['documentoDOC']}
            </a>
          </div>
          <div class="options">
            <a
              href="#"
              onclick="return false;"
              on:click={() => openDocument(documentoFileDoc)}>
              <img
                class="imgButton"
                src="/images/revista/download.svg"
                alt="View Icon"
                on:click={() => openDocument(documentoFileDoc)} />
            </a>
          </div>
        </div>
        <div class="manuscript">
          <div class="imageIcon">
            <a
              href="#"
              onclick="return false;"
              on:click={() => openDocument(documentoFilePdf)}>
              <img src="/images/revista/pdf.svg" alt="Document PDF" />
            </a>
          </div>
          <div class="description">
            <a
              href="#"
              onclick="return false;"
              on:click={() => openDocument(documentoFilePdf)}>
              {dict['documentoPDF']}
            </a>
          </div>
          <div class="options">
            <a
              href="#"
              onclick="return false;"
              on:click={() => openDocument(documentoFilePdf)}>
              <img
                class="imgButton"
                src="/images/revista/download.svg"
                alt="View Icon" />
            </a>
          </div>
        </div>
      </div>
      <div class="articleRow">
        <div class="subtitle">{dict['figuras']}:</div>
        {#each documento.figuras as figura, index}
          <ArticleFigureItem
            {index}
            imagen={figurasDoc[index]}
            descripcion={figura.descripcion}
            last={index === documento.figuras.length - 1} />
        {/each}
      </div>
      {#if miRol === 'Revisor'}
        {#if lettersAuthorsDoc[0] !== ''}
          <div class="articleRow">
            <div class="subtitle">{dict['miRevision']}:</div>
            {#each revisores as reviewer, index}
              {#if reviewer.soyYo}
                <ArticleVersionReviewerItem
                  {reviewer}
                  {index}
                  {version}
                  {miRol}
                  revisionDocAuthors={lettersAuthorsDoc[0]}
                  revisionDocEditors={lettersEditorsDoc[0]}
                  last={true} />
              {/if}
            {/each}
          </div>
        {/if}
      {:else if showReviewers}
        <div class="articleRow">
          <div class="subtitle">{dict['revisores']}:</div>
          {#each revisores as reviewer, index}
            {#if (miRol !== 'Autor' && miRol !== 'AutorGestor') || ((miRol === 'Autor' || miRol === 'AutorGestor') && lettersAuthorsDoc[index])}
              <ArticleVersionReviewerItem
                {reviewer}
                {index}
                {version}
                {miRol}
                revisionDocAuthors={lettersAuthorsDoc[index]}
                revisionDocEditors={lettersEditorsDoc[index]}
                last={index === revisores.length - 1} />
            {/if}
          {/each}
        </div>
      {/if}
    {/if}
  {/if}
</div>
